import { EnvironmentConfiguration } from './environment-config';

export const environment: EnvironmentConfiguration = {
	production: false,
	organizationUUID: 'c2109b33-68e7-4395-8547-81d434e4c61e', //Multitrax
	// organizationUUID: '4f718a7b-5bcb-4007-8767-60542e967ff7', //caffini
	authenticationUrl: 'https://keycloak-dev.datalean.it/realms/addiction',
	mediaLibraryUrl: 'https://api.dev.datalean.it/media-library/v2/',
	configUrl: 'https://api.dev.datalean.it/configuration/config/',
	userUrl: 'https://api.dev.datalean.it/idm-user/v2/',
	featureValueUrl: 'https://api.dev.datalean.it/feature/featureValue/v2/',

	quotationUrl: 'https://api.dev.datalean.it/multitrax-be/quotation/',
	// quotationUrl: 'http://localhost:3040/quotation/',
	structureUrl: 'https://api.dev.datalean.it/structure/v2/',
	productUrl: 'https://api.dev.datalean.it/core-entities/product/v3/',
	pageSize: 15,
	availableLocales: ['it-IT'],
	defaultLocale: 'it-IT',
	registration: {
		enabled: false,
		url: (typeof window !== 'undefined' ? window?.location.origin : '') + '/registration',
	},
	dataleanAppConfigKeys: {
		practiceFooterText: 'practiceFooterText',
	},
	sugarIframe: {
		tokenUrl: 'https://api.dev.datalean.it/multitrax-be/sugar-auth/token',
		allowedOrigins: ['https://testmultitrax.sugaropencloud.eu', 'http://localhost:8080'],
		sugarUrl: 'https://api.dev.datalean.it/multitrax-be/sugar/',
		// sugarUrl: 'http://localhost:3040/sugar/',
	},
};
